import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { map, catchError, finalize } from 'rxjs/operators';
import Swal from 'sweetalert2';

import { LoaderService } from 'app/loader/loader.service';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor( public router: Router, public loaderService: LoaderService) {}
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

	const currentRoute = this.router.url;

    // Exclude loader for dashboard component
    if (currentRoute.includes('/apps/dashboard/dashboard')) {
      return next.handle(request);

	//   AT
    } if (currentRoute.includes('/apps/autorepaycharts/autorepaycompanybasepie')) {
		return next.handle(request);
	  } if (currentRoute.includes('/apps/autorepaycharts/autorepaycompanybasepie')) {
		return next.handle(request);
	  }if (currentRoute.includes('/apps/autorepaycharts/autorepaycompanybasebar')) {
		return next.handle(request);
	  }
	  if (currentRoute.includes('/apps/autorepaycharts/autorepayindividualsingleline')) {
		return next.handle(request);
	  }
	  if (currentRoute.includes('/apps/autorepaycharts/autorepaycompanybasedonut')) {
		return next.handle(request);
	  }
	  if (currentRoute.includes('/apps/autorepaycharts/autorepayonestopsingleline')) {
		return next.handle(request);
	  }
	  if (currentRoute.includes('/apps/autorepaycharts/autorepayonestopbar')) {
		return next.handle(request);
	  }
	  if (currentRoute.includes('/apps/autorepaycharts/autorepaytop20loading')) {
		return next.handle(request);
	  }
	  if (currentRoute.includes('/apps/autorepaycharts/autorepaytoptenpie')) {
		return next.handle(request);
	  }
	  if (currentRoute.includes('/apps/autorepaycharts/autorepaytoptenloading')) {
		return next.handle(request);
	  }
	//   AR
	if (currentRoute.includes('/apps/charts/companybasepie')) {
		return next.handle(request);
	  }
	  if (currentRoute.includes('/apps/charts/companybaseloading')) {
		return next.handle(request);
	  }
	  if (currentRoute.includes('/apps/charts/companybasebar')) {
		return next.handle(request);
	  }
	  if (currentRoute.includes('/apps/charts/companybasesingleline')) {
		return next.handle(request);
	  }
	  if (currentRoute.includes('/apps/charts/companytopdonut')) {
		return next.handle(request);
	  }
	  if (currentRoute.includes('/apps/charts/companytopsingleline')) {
		return next.handle(request);
	  }
	  if (currentRoute.includes('/apps/charts/companytopbar')) {
		return next.handle(request);
	  }
	  if (currentRoute.includes('/apps/charts/companytop20loading')) {
		return next.handle(request);
	  }
	  if (currentRoute.includes('/apps/charts/individualdonut')) {
		return next.handle(request);
	  }
	  if (currentRoute.includes('/apps/charts/individualbasesingleline')) {
		return next.handle(request);
	  }
	  if (currentRoute.includes('/apps/charts/individualbasebar')) {
		return next.handle(request);
	  }
	  if (currentRoute.includes('/apps/charts/individualloading')) {
		return next.handle(request);
	  }
	this.loaderService.show();
    const skipURL = 'AdminPanel/login';
	const authToken = localStorage.getItem('token');
	if(request.url.search(skipURL) === -1) {
		request = request.clone({
		setHeaders: {
			Authorization: `Token ${authToken}`
		}
		});
	}
    
	return next.handle(request).pipe(map((event: HttpEvent<any>) => {
		console.log(event);
		
		if(event instanceof HttpResponse) {
			
		}
		return event;
	}),
	catchError(err => { console.log(err);
		this.loaderService.hide();
		// Swal.fire("TRy again!!", err.error.message);
		if(err.error.error && (err.status == 403 || err.status == 401)) {
			this.router.navigate(['apps/login/login']);
		}
	  const errorMsg = err.error.message;
	  return throwError(err);
	  
    }),finalize(() => {
    this.loaderService.hide();
    }));
	
  }
}